export default "__VITE_ASSET__B5xAX3ZZ__"